angular.module('bmsApp.trugreen.bulkPriceUpdate').factory('TGBulkPriceUpdateSvc', function (CRUDSvc) {

	var self = {
		preview: function (params) {
			return CRUDSvc.post('api/trugreen/bulk-price-update/preview', params);
		}
	};
	return self;

});
